import { IonButton } from '@ionic/react';
import { useIntl } from 'react-intl';
import { BundleMessages } from '../../intl/BundleMessages';
import { downloadBundleTemplate } from '../../redux/api/bundles';
import { useCallback } from 'react';

export const BundleTemplateDownloadButton: React.FC = () => {
  const { formatMessage } = useIntl();

  const handleDownload = useCallback(async () => {
    await downloadBundleTemplate();
  }, []);

  return (
    <IonButton onClick={handleDownload} color="primary" fill="outline">
      {formatMessage(BundleMessages.downloadTemplateButtonLabel)}
    </IonButton>
  );
};
